import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="rental-filter"
export default class extends Controller {
  static targets = ["button"];

  connect() {
    // Initialize the controller
  }

  filter(event) {
    const button = event.currentTarget;
    const type = button.dataset.type;
    button.classList.add("btn-primary");
    button.classList.remove("btn-white");
    Turbo.visit(`/rentals?rental_type=${type}`);
  }
}
